export const SMARTBRIEF_ROOT = "https://www.smartbrief.com";
export const NEWSLETTER_ROOT = "https://newsletter.smartbrief.com";
export const CAMPAIGN_TAG = "838290bd";
